import type { ColProps as BSColProps } from 'react-bootstrap'

import { Col as BSCol } from 'react-bootstrap'
import styled from 'styled-components'

import { elementStyle } from 'styles/element-style'

export interface ColProps extends BSColProps, IElement {
  children?: React.ReactNode
}

const StyledCol = styled(BSCol)`
  ${elementStyle}
`

export const Col: React.FC<ColProps> = (props: ColProps) => <StyledCol {...props} />
